import { format } from "date-fns-tz";

export function formatEpochTimeSeconds(epochTimeSeconds) {
  const expiresAt = new Date(epochTimeSeconds * 1000);
  const time = format(expiresAt, "HH:mm");
  const date = format(expiresAt, "dd/MM/yyyy");
  return { date, time };
}

export function isEpochTimeBeforeNow(epochTimeSeconds) {
  const now = new Date();
  const expiresAt = new Date(epochTimeSeconds * 1000);
  return expiresAt - now < 0;
}
